<template>
  <div class="paradigm_home_banner_footer">
    <div class="paradigm_home_banner_footer_item">
      <span class="paradigm_home_banner_footer_memo">面试企业</span>
      <div class="paradigm_home_banner_footer_num">
        <span class="paradigm_home_banner_footer_value">
          <numberControl :num="staticList.company"></numberControl> </span
        ><span class="paradigm_home_banner_footer_symbol">+</span>
      </div>
    </div>
    <div class="paradigm_home_banner_footer_item">
      <span class="paradigm_home_banner_footer_memo">面试人数</span>
      <div class="paradigm_home_banner_footer_num">
        <span class="paradigm_home_banner_footer_value"
          ><numberControl
            :num="staticList.intervieweeCount"
          ></numberControl></span
        ><span class="paradigm_home_banner_footer_symbol">+</span>
      </div>
    </div>
    <div class="paradigm_home_banner_footer_item">
      <span class="paradigm_home_banner_footer_memo">面试时长（h）</span>
      <div class="paradigm_home_banner_footer_num">
        <span class="paradigm_home_banner_footer_value"
          ><numberControl :num="staticList.duration"></numberControl></span
        ><span class="paradigm_home_banner_footer_symbol">+</span>
      </div>
    </div>
    <div class="paradigm_home_banner_footer_item">
      <span class="paradigm_home_banner_footer_memo">面试城市</span>
      <div class="paradigm_home_banner_footer_num">
        <span class="paradigm_home_banner_footer_value"
          ><numberControl :num="staticList.citys"></numberControl></span
        ><span class="paradigm_home_banner_footer_symbol">+</span>
      </div>
    </div>
  </div>
</template>

<script>
import numberControl from '@/components/tools/random-number'
export default {
  components: {
    numberControl,
  },
  data() {
    return {
      staticList: {},
    }
  },
  computed: {
    loadConfig() {
      return this.$store.state.app.config
    },
  },
  mounted() {
    if (this.loadConfig.interviewStatic) {
      this.staticList = this.loadConfig.interviewStatic
    }
  },
  watch: {
    loadConfig(newVal, oldVal) {
      if (newVal.interviewStatic) {
        this.staticList = newVal.interviewStatic
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.paradigm_home_banner_footer {
  width: 100%;
  height: 150px;
  box-sizing: border-box;
  padding-top: 42px;
  display: flex;
  justify-content: center;
  background-color: rgba(15, 16, 31, 0.7);
  position: absolute;
  bottom: 60px;
}

.paradigm_home_banner_footer_item {
  text-align: center;
  margin-right: 5%;
}
.paradigm_home_banner_footer_item:last-child {
  margin-right: 0;
}

.paradigm_home_banner_footer_value {
  font-size: 40px;
  line-height: 60px;
  font-weight: bold;
  color: white;
}

.paradigm_home_banner_footer_symbol {
  vertical-align: super;
  margin-top: -20px;
  font-size: 20px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 3px;
  color: white;
}

.paradigm_home_banner_footer_memo {
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  margin-top: 4px;
  display: inline-block;
  letter-spacing: 2.1px;
  color: #29bdb9;
}
.paradigm_home_banner_footer_num {
  position: relative;
  right: -15px;
}
@media screen and (max-width: 600px) {
  .paradigm_home_banner_footer {
    position: initial;
    display: inline-block;
    height: initial;
    padding: 15px 0px 10px;
    .paradigm_home_banner_footer_item {
      width: 50%;
      float: left;
      display: inline-table;
      margin: 0px;
      text-align: center;

      .paradigm_home_banner_footer_value {
        font-size: 25px;
      }
      .paradigm_home_banner_footer_symbol {
        vertical-align: text-top;
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .paradigm_home_banner_footer {
    position: initial;
    display: inline-block;
    height: initial;
    padding: 15px 0px 10px;
    .paradigm_home_banner_footer_item {
      width: 50%;
      float: left;
      display: inline-table;
      margin: 0px;
      text-align: center;
      .paradigm_home_banner_footer_value {
        font-size: 27px;
      }
      .paradigm_home_banner_footer_symbol {
        vertical-align: text-top;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/interview/static.vue